import { FiExternalLink as _FiExternalLink } from "@react-icons/all-files/fi/FiExternalLink.js";
import React from 'react';
import { Box, Flex, Select, Text } from 'core/components';
import FilteredDevicesLink from 'app/components/links/FilteredDevicesLink';
var TrafficPakVizHeader = function TrafficPakVizHeader(_ref) {
  var id = _ref.id,
    leftText = _ref.leftText,
    lookback = _ref.lookback,
    handleTimePeriodChange = _ref.handleTimePeriodChange,
    showSelect = _ref.showSelect,
    timePeriodOptions = _ref.timePeriodOptions;
  return /*#__PURE__*/React.createElement(Flex, {
    justifyContent: "space-between",
    alignItems: "center",
    my: 1
  }, /*#__PURE__*/React.createElement(Text, {
    fontSize: 14,
    color: "muted"
  }, leftText), /*#__PURE__*/React.createElement(Flex, {
    alignItems: "center"
  }, showSelect && /*#__PURE__*/React.createElement(Box, {
    mr: 2
  }, /*#__PURE__*/React.createElement(Select, {
    options: timePeriodOptions,
    values: lookback.value,
    onChange: handleTimePeriodChange,
    placeholder: "Select time period",
    width: 100
  })), /*#__PURE__*/React.createElement(FilteredDevicesLink, {
    filters: {
      plan: ["".concat(id)],
      isArchived: false
    }
  }, /*#__PURE__*/React.createElement(Flex, {
    alignItems: "center"
  }, /*#__PURE__*/React.createElement(Text, {
    mr: "4px",
    textDecoration: "underline"
  }, "Go to Devices"), /*#__PURE__*/React.createElement(_FiExternalLink, null)))));
};
export default TrafficPakVizHeader;